import { isError } from "lodash";
import { AxiosError } from "axios";
import { ErrorResponse } from "api";
import { ErrorCodeType } from "./types";
import { errorCodes } from "./code";

export const isAxiosError = (arg: unknown): arg is AxiosError => {
  if (!isError(arg)) return false;
  const value = arg as AxiosError;
  if (value.isAxiosError) {
    return true;
  }
  return false;
};

export const isErrorResponse = (arg: unknown): arg is ErrorResponse => {
  const content = arg as ErrorResponse;
  if (content === undefined) {
    return false;
  }
  if (content.code === undefined) {
    return false;
  }
  if (content.message === undefined) {
    return false;
  }

  return true;
};

export const isErrorCode = (arg: string): arg is ErrorCodeType => {
  if (errorCodes.includes(arg as ErrorCodeType)) {
    return true;
  }
  return false;
};
